import { GetServerAuditTrailRequest, GetServerAuditTrailResponse } from "../../../domain/repositories/ConfigRepository";

export const TRIGGER_GET_SERVER_AUDIT_TRAIL = 'GET_SERVER_AUDIT_TRAIL.TRIGGER';
export const GET_SERVER_AUDIT_TRAIL_PENDING = 'GET_SERVER_AUDIT_TRAIL.PENDING';
export const GET_SERVER_AUDIT_TRAIL_SUCCESS = 'GET_SERVER_AUDIT_TRAIL.SUCCESS';
export const GET_SERVER_AUDIT_TRAIL_ERROR = 'GET_SERVER_AUDIT_TRAIL.ERROR';

export const RESET_GET_SERVER_AUDIT_TRAIL = 'GET_SERVER_AUDIT_TRAIL.RESET';

export interface TriggerGetServerAuditTrail {
  type: typeof TRIGGER_GET_SERVER_AUDIT_TRAIL;
  payload: {
    request: GetServerAuditTrailRequest;
  };
}

export interface GetServerAuditTrailPending {
  type: typeof GET_SERVER_AUDIT_TRAIL_PENDING;
}

export interface GetServerAuditTrailSuccess {
  type: typeof GET_SERVER_AUDIT_TRAIL_SUCCESS;
  payload: {
    response: GetServerAuditTrailResponse;
  }
}

export interface GetServerAuditTrailError {
  type: typeof GET_SERVER_AUDIT_TRAIL_ERROR;
}

export interface ResetGetServerAuditTrail {
  type: typeof RESET_GET_SERVER_AUDIT_TRAIL;
}


export type GetServerAuditTrailActionType =
  | TriggerGetServerAuditTrail
  | GetServerAuditTrailPending
  | GetServerAuditTrailSuccess
  | GetServerAuditTrailError
  | ResetGetServerAuditTrail;


export interface GetServerAuditTrailState {
  getServerAuditTrailPending: boolean;
  getServerAuditTrailError: boolean;
  serverAuditTrailResponse: GetServerAuditTrailResponse | null;
}